import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { EmployeeInfoService } from '../services/employee-info.service';
import { LanguagePackService } from '../services/language-pack.service';

@Injectable({
  providedIn: 'root'
})
export class EmployeeInfoResolverService implements Resolve<any> {

  constructor(private http: HttpClient, private employeeInfoService: EmployeeInfoService, private languagePackService: LanguagePackService) { }

  resolve(): any {
    if (this.employeeInfoService.getEmployeeInfo() == null) {
      return this.http.get('/Employee/GetInfo')
        .toPromise()
        .then((response) => {
          this.employeeInfoService.setEmployeeInfo(response);
          var employeeInfo = this.employeeInfoService.getEmployeeInfo();
          if (employeeInfo != null) {
            return this.http.get('/Employee/GetLanguagePack?language=' + employeeInfo.LanguageCode)
              .toPromise()
              .then((languageResponse) => {
                this.languagePackService.setLanguagePack(languageResponse);
              });
          }
        });
    }
  }
}
